import type { K8s } from '@/entities/kubernetes';
import type { RequestMeta, ResponseMeta } from '@/shared/api';
import request from '@/shared/api/request';

export const getKubernetesClusters = (
  params?: RequestMeta,
): Promise<{ kubernetes: K8s[]; meta: ResponseMeta }> =>
  request({
    url: '/kubernetes/',
    params,
  });
